<ng-container
  *ngLet="{
    filterable: defaultedFilterable | async,
    disabled: defaultedDisabled | async,
    exact: defaultedExact | async,
    options: defaultedOptions | async,
    nodes: nodes | async,
    nodesLoadable: matchedNodesLoadable | async,
    notShownCount: notShownCount | async,
    filterPositionBottom: defaultedFilterPositionBottom | async,
    filter: filter | async,
    optionsVisibleState: optionsVisibleState | async
  } as vm"
>
  <option-filter
    [class.container-padding]="type != 'search'"
    class="container"
    *ngIf="vm.filterable && (!noResultsText || vm.nodes.length)"
    [autoFocus]="true"
    [placeholder]="placeholder"
    [disabled]="vm.disabled"
    [queryParamName]="queryParamName"
    [filterEmpty]="!!vm.filter && (!vm.nodes || !vm.nodes.length)"
    [hideOptions]="
      (!vm.filter && (!vm.nodes || !vm.nodes.length)) || !vm.optionsVisibleState
    "
    [filter]="vm.filter"
    [inputPositionBottom]="vm.filterPositionBottom"
    (filterChange)="doFilter.next($event); filterChange.emit($event)"
    (focus)="showOptions.next(true)"
    [type]="type"
  >
    <div class="options-outer">
      <loadable [data]="vm.nodesLoadable">
        <div class="options">
          <ng-container
            *ngTemplateOutlet="nodesTemplate; context: { $implicit: vm.nodes }"
          ></ng-container>
        </div>
      </loadable>
    </div>
  </option-filter>
  <div
    class="container"
    *ngIf="!vm.filterable && (!noResultsText || vm.nodes.length)"
  >
    <div>
      <ng-container
        *ngTemplateOutlet="nodesTemplate; context: { $implicit: vm.nodes }"
      ></ng-container>
    </div>
  </div>
  <div class="container" *ngIf="noResultsText && !vm.nodes.length">
    <div class="empty">{{ noResultsText }}</div>
  </div>
  <ng-template #nodesTemplate let-nodes>
    <div>
      <ng-container *ngIf="nodeDirective">
        <ng-container
          #nodeRef
          (click)="onNodeClicked(node.id)"
          *ngFor="let node of nodes"
        >
          <ng-container
            *ngTemplateOutlet="
              nodeDirective.template;
              context: { $implicit: node, clickHandler: this }
            "
          ></ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="!nodeDirective">
        <single-select-node
          #nodeRef
          *ngFor="let node of nodes; let i = index; trackBy: trackBy"
          [disabled]="nodeDisabled(vm.disabled, i)"
          [displayId]="displayId"
          [node]="node"
          (clicked)="onNodeClicked(node.id)"
        ></single-select-node>
      </ng-container>
      <div class="more" *ngIf="vm.notShownCount > 0">
        {{ vm.notShownCount }} more... (Search to narrow results)
      </div>
    </div>
  </ng-template>
</ng-container>
